import React from "react";

const BS5_Flex = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Flex Component</h2>
      <p>This is the BS5_Flex component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Flex;
